import { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

export default function QRCodeGenerator({ link, show }) {
  const downloadQRCode = async () => {
    try {
      const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
        link
      )}`;

      // Fetch the image
      const response = await fetch(qrUrl);
      const blob = await response.blob();

      // Create download link
      const url = URL.createObjectURL(blob);
      const link_element = document.createElement("a");
      link_element.href = url;
      link_element.download = `store-menu-qr-code-${Date.now()}.png`;

      // Trigger download
      document.body.appendChild(link_element);
      link_element.click();
      document.body.removeChild(link_element);

      // Clean up
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading QR code:", error);
      alert("Failed to download QR code. Please try again.");
    }
  };

  return (
    <div className=" my-3">
      <div
        style={{
          display: show ? "flex" : "none",
          width: "100px",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${link}`}
          alt="qr-code"
          style={{ width: "100px", heigh: "100px" }}
        />
        <button onClick={downloadQRCode} className=" mt-1" type="button">
          Download
        </button>
      </div>
    </div>
  );
}
